export default __webpack_public_path__ + "static/media/icw-form.45b44673.jpg";